__turbopack_context__.v({
  "container": "CompareBoats-module-scss-module__MGCLOW__container",
  "header": "CompareBoats-module-scss-module__MGCLOW__header",
  "headerWrapper": "CompareBoats-module-scss-module__MGCLOW__headerWrapper",
  "tableWrapper": "CompareBoats-module-scss-module__MGCLOW__tableWrapper",
});
